import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function CashRegisterSessionDetail({ children }) {
  useInjectSaga({ key: 'reportsCashRegisterSessionDetail', saga });
  useInjectReducer({ key: 'reportsCashRegisterSessionDetail', reducer });

  return React.Children.only(children);
}

CashRegisterSessionDetail.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReportsCashRegisterSessionDetail } from './withReportsCashRegisterSessionDetail';
export default compose(withConnect, memo)(CashRegisterSessionDetail);
